import { create } from 'zustand';

// Dismissing the lecture player collapses it back to the plain board, ready to be inked;
// the filmstrip tile for that unit re-opens it through useSelectUnit.
// Keyed by unit id, not a bare flag: a different unit can never inherit a dismissal.
interface LecturePlayerState {
  collapsedUnitId: string | null;
  collapse: (unitId: string) => void;
  expand: () => void;
}

export const useLecturePlayerStore = create<LecturePlayerState>((set) => ({
  collapsedUnitId: null,
  collapse: (unitId) => set({ collapsedUnitId: unitId }),
  expand: () => set({ collapsedUnitId: null }),
}));
